import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Organisations from '../components/Organisations';
import CreateOrganisation from '../containers/CreateOrganisation';
import EditOrganisation from '../containers/EditOrganisation';
import OrganisationDetails from '../components/OrganisationDetails';
import { TABS, PRINCIPAL_ACTIONS } from '../constants';
import PrincipalDetail from '../components/principals/PrincipalDetail';

const OrganisationsScene = () => (
  <Routes>
    <Route index element={<Organisations menuName="Organisations" />} />
    <Route path="new" element={<CreateOrganisation menuName="Organisations" />} />
    <Route path=":id/edit" element={<EditOrganisation menuName="Organisations" />} />
    <Route
      path={`:id/${TABS.PRINCIPALS}/${PRINCIPAL_ACTIONS.DETAILS}/:actionId/:tab?/:action?`}
      element={<PrincipalDetail menuName="Organisations" />}
    />
    <Route
      path=":id/:tab?/:action?/:actionId?"
      element={<OrganisationDetails menuName="Organisations" />}
    />
  </Routes>
);

export default OrganisationsScene;
